
var Mousetrap = null;

export function loadMouseTrap(){
	return import(/* webpackChunkName: "mousetrap" */ "mousetrap")
		.then((resp) => {
			Mousetrap = resp;
		});
}

export function setKey(key, func, reload = true){
	try {
		Mousetrap.bind(key, func);
	} catch (err){
		if(reload){
			loadMouseTrap()
				.then(() => {
					setKey(key, func, false);
				});
		}
	}
}

export function removeKey(...keys){
	try {
		keys.forEach(v => Mousetrap.unbind(v));
	} catch (err) {
	}
}
